import TableComponent from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import {
  downloadFormPayments,
  getFormBuilderPaymentReports,
  getFormList,
} from "store/actions"
import { getCurrentTimeZone } from "containers/Communications/utils"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { withRouter } from "react-router-dom"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import formBuilderTransactionsListColumns from "containers/Dashboard/formBuilderTransactionsListColumns"

const FormPayments = ({
  getFormBuilderPaymentReports,
  formBuilderPaymentReports,
  history,
  formList,
  getFormList,
  downloadFormPayments,
}) => {
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [formValue, setFormValue] = useState(null)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "created_at",
    od: "desc",
  })

  useEffect(() => {
    getFormBuilderPaymentReports({
      ...defaultOrder,
      page: 1,
      per_page: 15,
      timezone: getCurrentTimeZone(),
    })
    getFormList({})
  }, [])

  const searchHanler = () => {
    getFormBuilderPaymentReports({
      ...defaultOrder,
      page: 1,
      per_page: 15,
      timezone: getCurrentTimeZone(),
      ...(startDate.trim().length ? { start: startDate } : {}),
      ...(endDate.trim().length ? { end: endDate } : {}),
      ...(formValue?.value ? { form_builder_id: formValue?.value } : {}),
    })
    setShowResetButton(true)
  }

  const resetSearchHandler = () => {
    getFormBuilderPaymentReports({
      ...defaultOrder,
      page: 1,
      per_page: 15,
      timezone: getCurrentTimeZone(),
    })
    setShowResetButton(false)
    setStartDate("")
    setEndDate("")
    setFormValue(null)
  }

  const handlePageChange = page => {
    getFormBuilderPaymentReports({
      ...defaultOrder,
      page: page,
      per_page: 15,
      timezone: getCurrentTimeZone(),
      ...(startDate.trim().length ? { start: startDate } : {}),
      ...(endDate.trim().length ? { end: endDate } : {}),
      ...(formValue?.value ? { form_builder_id: formValue?.value } : {}),
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getFormBuilderPaymentReports({
      o: sortField,
      od: sortOrder,
      page: 1,
      per_page: 15,
      timezone: getCurrentTimeZone(),
      ...(startDate.trim().length ? { start: startDate } : {}),
      ...(endDate.trim().length ? { end: endDate } : {}),
      ...(formValue?.value ? { form_builder_id: formValue?.value } : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Form Payments" />
        <Container fluid>
          <BreadcrumbTitle
            title="Form Payments"
            breadcrumbItems={[
              { title: "Dashboard" },
              { title: "Form Payments" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Back"
                color="light"
                onClick={() => history.goBack()}
              />
            </Col>
          </Row>
          <Card>
            <CardBody>
              <Row className="mb-2">
                <Col>Timezone: {getCurrentTimeZone()}</Col>
                {formBuilderPaymentReports?.data?.length > 0 && (
                  <Col xs="auto">
                    <SaveButton
                      type="button"
                      content="Download Report"
                      onClick={() => {
                        downloadFormPayments({
                          ...defaultOrder,
                          page: 1,
                          per_page: 15,
                          timezone: getCurrentTimeZone(),
                          ...(startDate.trim().length
                            ? { start: startDate }
                            : {}),
                          ...(endDate.trim().length ? { end: endDate } : {}),
                          ...(formValue?.value
                            ? { form_builder_id: formValue?.value }
                            : {}),
                          download: true,
                        })
                      }}
                    />
                  </Col>
                )}
              </Row>
              <Row className="justify-content-center mb-3">
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="Start Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={startDate}
                    onChange={(selectedDates, dateStr) => {
                      setStartDate(dateStr)
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="End Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={endDate}
                    onChange={(selectedDates, dateStr) => {
                      setShowResetButton(true)
                      setEndDate(dateStr)
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <div style={{ width: "200px" }}>
                    <Select
                      value={formValue}
                      placeholder="Form Builder"
                      onChange={v => {
                        setShowResetButton(true)
                        setFormValue(v)
                      }}
                      options={formList?.map(x => ({
                        value: x?.id,
                        label: x?.name,
                      }))}
                      isSearchable={false}
                    />
                  </div>
                </Col>
                <Col xs="auto" className="my-1">
                  <SaveButton
                    type="button"
                    content="Filter"
                    onClick={searchHanler}
                  />
                </Col>
                {showResetButton && (
                  <Col xs="auto" className="my-1">
                    <SaveButton
                      type="button"
                      content="Reset"
                      color="light"
                      onClick={resetSearchHandler}
                    />
                  </Col>
                )}
              </Row>
              <Row className="mt-2">
                <Col>
                  <TableComponent
                    data={
                      formBuilderPaymentReports?.data?.map((item, index) => ({
                        ...item,
                        id: index,
                      })) || []
                    }
                    columns={formBuilderTransactionsListColumns()}
                    paginationData={{
                      current_page: formBuilderPaymentReports?.current_page,
                      last_page: formBuilderPaymentReports?.last_page,
                      total_items: formBuilderPaymentReports?.total,
                      items_per_page: formBuilderPaymentReports?.per_page,
                      from: formBuilderPaymentReports?.from,
                      to: formBuilderPaymentReports?.to,
                      first_page: 1,
                    }}
                    onPageChange={handlePageChange}
                    onTableSort={handleSort}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  formBuilderPaymentReports: state.Analytics.formBuilderPaymentReports,
  formList: state.Analytics.formList,
})

const mapDispatchToProps = dispatch => ({
  getFormBuilderPaymentReports: values =>
    dispatch(getFormBuilderPaymentReports(values)),
  getFormList: values => dispatch(getFormList(values)),
  downloadFormPayments: values => dispatch(downloadFormPayments(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FormPayments))
